<template>
  <a-drawer width="70%" :label-col="4" :wrapper-col="14" :visible="open"  @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{$t('订单详情')}}</b>
    </a-divider>
    <!--订单状态步骤条-->
    <a-steps v-if="this.record.id" :current="this.record.refundStatus" size="small">
      <a-step v-for="(item, index) in this.record.operateLogList" :key="index" >
        <template slot="title">
          <div style=" font-size: 18px">{{item.statusEvent}}</div>
          <div>{{item.orderStatusName}}</div>
          <div v-if="item.remark">{{item.remark}}</div>
          <div>{{item.createTime}}</div>
        </template>
      </a-step>
    </a-steps>

    <div class="order-info">
      <table>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" :title="$t('原订单信息')"
                    :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                    :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">{{$t('订单编号')}}：</td>
                  <td class="data">
                    {{ this.record.orderSellDetail.id}}
                  </td>
                  <td class="first">{{$t('订单状态')}}：</td>
                  <td class="data">
                    <custom-dict-tag :options="customDict.OrderRefundStatusEnum" :value="record.refundStatus"/>
                  </td>
                  <td class="first">{{$t('下单时间')}}：</td>
                  <td class="data">
                    {{ this.record.orderSellDetail.createTime}}
                  </td>
                </tr>
                <tr>
                  <td class="first">{{$t('订单来源')}}：</td>
                  <td class="data">
                    <custom-dict-tag :options="customDict.SourceEnum" :value="record.orderSellDetail.source"/>
                  </td>
                  <td class="first">{{$t('买家名称')}}：</td>
                  <td class="data">
                    {{ this.record.orderSellDetail.buyerName}}
                  </td>
                </tr>
                <tr>
                  <td class="first">{{$t('支付时间')}}：</td>
                  <td class="data">
                    {{ this.record.orderSellDetail.payTime}}
                  </td>
                  <td class="first">{{$t('支付方式')}}：</td>
                  <td class="data">
                    <custom-dict-tag :options="customDict.OrderPayTypeEnum" :value="record.orderSellDetail.payType"/>
                  </td>
                  <td class="first">{{$t('三方订单号')}}：</td>
                  <td class="data">
                    {{ this.record.orderSellDetail.outTradeNo}}
                  </td>
                </tr>
                <tr>
                  <td class="first">{{$t('订单金额')}}：</td>
                  <td class="data">
                    {{ this.record.orderSellDetail.orderAmount}}
                  </td>
                  <td class="first">{{$t('商品金额')}}：</td>
                  <td class="data">
                    {{ this.record.orderSellDetail.goodsAmount}}
                  </td>
                  <td class="first">{{$t('商品数量')}}：</td>
                  <td class="data">
                    {{ this.record.orderSellDetail.goodsCount}}
                  </td>
                </tr>
                <tr>
                  <td class="first">{{$t('实付金额')}}：</td>
                  <td class="data">
                    {{ this.record.orderSellDetail.payAmount}}
                  </td>
                  <td class="first">{{$t('运费金额')}}：</td>
                  <td class="data">
                    {{ this.record.orderSellDetail.shippingAmount}}
                  </td>
                  <td class="first">{{$t('运费实付')}}：</td>
                  <td class="data">
                    {{ this.record.orderSellDetail.shippingPayAmount}}
                  </td>
                </tr>
                <tr>
                  <td class="first">{{$t('用户备注')}}：</td>
                  <td  colspan="7">
                    {{ this.record.orderSellDetail.userMessage}}
                  </td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" :title="$t('售后详情')"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">{{$t('售后单编号')}}：</td>
                  <td class="data">
                    {{ this.record.id}}
                  </td>
                  <td class="first">{{$t('售后状态')}}：</td>
                  <td class="data">
                    {{this.record.refundStatusName}}
                  </td>
                  <td class="first">{{$t('申请时间')}}：</td>
                  <td class="data">
                    {{ this.record.createTime}}
                  </td>
                </tr>
                <tr>
                  <td class="first">{{$t('售后类型')}}：</td>
                  <td class="data">
                    {{ this.record.refundTypeName}}
                  </td>
                  <td class="first">{{$t('退款金额')}}：</td>
                  <td class="data">
                    {{ this.record.refundAmount}}
                  </td>
                </tr>
                <tr>
                  <td class="first">{{$t('售后原因')}}：</td>
                  <td >
                    {{ this.record.reasonName}}
                  </td>
                  <td class="first">{{$t('售后凭证')}}：</td>
                  <td >
                    <img v-for="(item) in record.refundPicList" :src="item"  style="width:60px;height:62px;" @click="handleRecordPreview(item)" alt="none">
                  </td>
                  <td class="first">{{$t('备注')}}：</td>
                  <td >
                    {{ this.record.remark}}
                  </td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>
        <tr v-if="record.deliveryList && record.deliveryList.length>0">
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="物流信息"
                     :headStyle="{'background-color':'#f3f3f3','height': '10px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <a-table  :bordered="false" :pagination="false" :columns="deliveryColumns" rowKey="skuId" :data-source="record.deliveryList">
                <template slot="logisticDetail" slot-scope="text, deliveryRecord">
                  <div>
                    <a-button type="primary"  @click="openLogistics(deliveryRecord.logisticsNo)">
                      {{$t('物流详情')}}
                    </a-button>
                  </div>
                </template>
                <span slot="remark" slot-scope="text, record">
                  <span
                    @click="toggleContentsExpand(record.id)" style="cursor: pointer;"
                    v-html="getContentsHtml(record)">
                  </span>
                  <a @click="expandedContents[record.id] ? toggleContentsExpand(record.id) : openContent(record.id)" style="margin-left: 8px; color: #1890ff;">
                    {{ expandedContents[record.id] ? '收起' : '查看' }}
                  </a>
                </span>
              </a-table>
            </a-card>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" :title="$t('售后商品')"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <a-table  :bordered="false" :pagination="false" :columns="goodsColumns" rowKey="skuId" :data-source="record.orderItemList">
                <template slot="picture" slot-scope="text, record">
                  <div>
                    <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
                  </div>
                </template>
              </a-table>
            </a-card>
          </td>
        </tr>

      </table>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <audit-form
        ref="auditForm"
        @ok="handleDetail(record.id)"
      />
      <contents-form ref="contentsForm"/>
    </div>
    <div class="bottom-control">
      <a-space>
        <a-button type="primary"  v-hasPermi="['order:refund:audit']"  v-if="this.record.refundStatus===5010" @click="$refs.auditForm.handleAudit(record.id)">
          {{$t('审核')}}
        </a-button>
        <a-button type="primary"  v-hasPermi="['order:refund:audit']"  v-if="this.record.refundStatus===5030" @click="handleDeliveryRefuse(record.id);">
          拒绝收货
        </a-button>
        <a-button type="primary"  v-hasPermi="['order:refund:audit']"  v-if="this.record.refundStatus===5030" @click="handleReceipt(record.id)">
          收货并退款
        </a-button>
        <a-button type="dashed" @click="cancel">
          {{$t('关闭')}}
        </a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import {auditRefund, getRefund, refundApply, refundReceipt} from '@/api/order/refund'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import AuditForm from "./AuditForm";
import ContentsForm from "./ContentsForm.vue";

export default {
  name: 'detailForm',
  props: {
  },
  components: {
    CustomDictTag,
    AuditForm,
    ContentsForm
  },
  data () {
    return {
      record: {
        id:null,
        orderSellDetail:{},
      } ,
      // 内容物展开状态
      expandedContents: {},
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      // 表单参数
      form: {
        id: null,
        outTradeNo: null,
        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      deliveryColumns: [
        {
          title: this.$t('物流单号'),
          dataIndex: 'logisticsNo',
          align: 'center',
        },
        {
          title: this.$t('物流公司'),
          dataIndex: 'logisticsName',
          align: 'center',
        },
        {
          title: this.$t('手机号'),
          dataIndex: 'deliveryMobile',
          align: 'center',
        },
        {
          title: this.$t('发货时间'),
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          scopedSlots: {customRender: 'remark'},
          align: 'center',
        },
        {
          title: this.$t('物流详情'),
          dataIndex: 'logisticDetail',
          scopedSlots: {customRender: 'logisticDetail'},
          align: 'center'
        },
      ],
      goodsColumns: [
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
          align: 'center',
        },
        {
          title: this.$t('商品主图'),
          dataIndex: 'picture',
          scopedSlots: {customRender: 'picture'},
          align: 'center'
        },
        {
          title: this.$t('规格名称'),
          dataIndex: 'skuName',
          align: 'center'
        },
        {
          title: this.$t('商品数量'),
          dataIndex: 'goodsCount',
          align: 'center'
        },
        {
          title: this.$t('售后数量'),
          dataIndex: 'refundCount',
          align: 'center'
        },
        {
          title: this.$t('包装单位'),
          dataIndex: 'unit',
          align: 'center'
        },
        {
          title: this.$t('商品价格'),
          dataIndex: 'price',
          align: 'center'
        },
        {
          title: this.$t('实付单价'),
          dataIndex: 'payPrice',
          align: 'center'
        },
      ],

      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        outTradeNo: null,
        remark: null,
      }
    },
    openLogistics(no) {
      const url = new URL('https://www.kuaidi100.com/chaxun');
      url.searchParams.set('nu', no);
      window.open(url.toString(), "_blank");
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },

    handleDetail(id) {
      this.reset()
      this.formType = 2
      getRefund({"id":id}).then(response => {
        this.record = response.data
        this.open = true
      })
    },
    openContent(id) {
      this.$refs.contentsForm.handleContent(id)
    },

    toggleContentsExpand(id) {
      this.$set(this.expandedContents, id, !this.expandedContents[id])
    },
    // HTML 转义函数
    escapeHtml(text) {
      if (!text) return ''
      const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }
      return text.replace(/[&<>"']/g, m => map[m])
    },

    getContentsHtml(record) {
      if (!record.remark) {
        return ''
      }

      const isExpanded = this.expandedContents[record.id]
      const maxChars = 14 // 默认显示14个字符

      if (isExpanded) {
        return record.remark
        // 展开状态
      } else {
        // 收起状态：只显示第一层的前14个字符
        const fullText =  record.remark
        let displayItems
        if (fullText.length <= maxChars) {
          // 内容长度小于等于最大字符数
          displayItems = fullText
        } else {
          // 收起状态，只显示前14个字符
          let currentLength = 0
          if (fullText.length > maxChars) {
            displayItems += '...'
          }
        }
        return `${displayItems}`
      }
    },

    handleReceipt(id) {
      let that = this
      let form = {"id":id }
      this.$confirm({
        title: this.$t('是否确认退款'),
        content: '此操作将确认收货,并退款',
        onOk () {
          that.record.refundStatus =5048
          refundReceipt(form).then(resp => {
            if (resp.code==='20001') {
              that.$message.success('退款成功', 3);
              that.handleDetail(id)
              that.record.refundStatus =5048
              this.open = false
              this.$emit('ok')
            }
          });
        },
        onCancel () {}
      })
    },

    handleDeliveryRefuse(id) {
      let that = this
      let form = {"id":id,"isPass":false }
      this.$confirm({
        title: this.$t('是否确认拒绝'),
        onOk () {
          auditRefund(form).then(resp => {
            if (resp.code==='20001') {
              that.$message.success('拒绝成功', 3);
              that.getList()
            }
          });
        },
        onCancel () {}
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            payAdvert(this.form).then(response => {
              this.$message.success(
                '支付成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  color: rgba(0, 0, 0, .85);
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.message-text {
  font-family: MicrosoftYaHei;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3rem;
  letter-spacing: 0rem;
  color: #333333;
  width: 50%;
}

.fontblack {
  color: #999999
}

.img2 {
  width: .81rem;
  height: .8rem;
  float: right;
}


.orderTitle {
  font-size: 1rem;
  color: #333333;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  height: 2.5rem;
}

.orderDetail {
  font-size: 0.8rem;
  color: #666666;
  text-align: left;
}

.border-ceter {
  width: 92%;
  padding-left: 15px;
  padding-right: 15px;
}

.pay-button {
  width: 88%;
  height: 2.6rem;
  position: relative;
  background-color: red;
  color: white;

  margin-left: 6%;
}

ul li {
  list-style: none;
  font-size: 1rem;
}

ul {
  padding-left: 1.5rem
}

.track-rcol {
}

.track-list {
  position: relative;
}

.track-list li {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 1rem;
  border-left: 1px solid #d9d9d9;
  color: #999;
}

.track-list li.first {
  color: red;
  padding-top: 0;
  width: 100%;
  text-align: left;
  border-left: 1px solid #d9d9d9;
}

.track-list li .node-icon {
  position: absolute;
  left: -5.5px;
  border-radius: 0.25rem;
  width: 0.5rem;
  height: 0.5rem;
  top: 4px;
  background-color: #999999;
}

.track-list li.first .node-icon {
  background-position: 0-72px;
  background-color: red;
  width: 1rem;
  z-index: 2;
  height: 1rem;
  position: absolute;
  left: -9px;
  top: 0;
  border-radius: 0.5rem;
}

.track-list li .time {
  margin-right: 20px;
  position: relative;
  top: 4px;
  display: inline-block;
  vertical-align: middle;
  background-color: white;
  color: #999;
  width: 100%;
  text-align: left;
}

.track-list li .txt {
  position: relative;
  display: inline-block;
  vertical-align: top;
  color: #999;
}

.track-list li.first .time {
  text-align: left;
  width: 94%;
  color: red;
}

.track-list li.first .txt {
  color: red;
  text-align: left;
  width: 94%;
}

.track-list li.finall {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 18px;
  border-color: white;
  border-left: 1px solid #ffffff;
  color: #999;
}

.track-list li.finall .div-spilander {
  width: 1px;
  position: absolute;
  position: absolute;
  left: -1.5px;
  height: 0.5rem;
  background-color: #d9d9d9;
}

.order-info {
  border: 1px solid #e8e8e8;
  margin-top: 40px;

  .info-table {
    tr {
      height: 50px;
    }
    td {
      display: table-cell;
      vertical-align: top;
      font-size: 16px;
    }

    .first {
      width: 100px;
    }

    .data {
      width: 300px;
    }
  }
}

.detailPanel {
  dd, dt {
    display: inline-block;
    vertical-align: center;
  }

  dt img {
    margin: 0 20px 5px 0px;
  }

  dd {
    h3 {
      font-weight: bold;
    }
  }

  .trade-detail-prompt {
    margin-left: 35px;

    li {
      font-size: 13px !important;

      .dotted-node {
        padding: 0 5px;
      }
    }
  }
}

.order-money {
  .om-c1 {
    font-size: 14px;
    color: #666
  }

  .om-c2 {
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }

  .om-c3 {
    font-size: 16px;
    color: #DE3636;
    font-weight: bold;
  }

  td {
    text-align: right;
  }

  float: right;
  margin: 20px 40px 20px 0;
}
</style>
